<template>
  <div>
    <main-layout>
      <v-tabs
        v-model="currentView"
        color="white"
        :slider-color="$vuetify.theme.primary"
        show-arrows
      >
        <v-tab ripple :key="'beacon'" :href="'#beacon'">
          {{ $t('Beacon') }}
        </v-tab>

        <v-tab ripple :key="'messages'" :href="'#messages'">
          {{ $t('Message') }}
        </v-tab>

        <v-tab ripple :key="'analytics'" :href="'#analytics'">
          {{ $t('Analytics') }}
        </v-tab>
      </v-tabs>
      <template v-if="currentView == 'beacon'" :value="'beacon'">
        <Beacon />
      </template>
      <template v-if="currentView == 'messages'" :value="'messages'">
        <Messages />
      </template>
      <template v-if="currentView == 'analytics'" :value="'analytics'">
        <Analytics />
      </template>
    </main-layout>
    <template> </template>
  </div>
</template>

<script>
import Beacon from './Beacon.vue'
import Messages from './Messages.vue'
import Analytics from './Analytics.vue'
export default {
  data() {
    return {
      currentView: 'beacon'
    }
  },
  components: {
    Beacon,
    Messages,
    Analytics
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/beacon/Controller.vue